export default "__VITE_ASSET__BQsyn1Yq__"